import React, {useState, useEffect} from 'react';
import Files from './Files';
import bootstrap from 'bootstrap';
import axios from 'axios';
import "./styles.scss";

function Permits() {

  const [folderData,setData] = useState([]);
  useEffect(() => {
    axios.get('https://cocwebservice.cityofcarrollton.com/coc-API/filedisplay?reporttype=PermitReports')
      .then(res => {
      //  console.log('Response form main API: ', res)
      //  console.log('Folder Data: ', res.data)
        setData(res.data);
      })
      .catch(err=>{
        console.log(err);
      })
  }, [])  
  return (
    <div className="container">
    <div className="accordion" id="accordionExample">
    <>
    {
        folderData.map((d) => {
          var head = "heading" + d.id;
          var colp1 = "#collapse" + d.id;
          var colp2 = "collapse" + d.id;
          var colp3 = "";
          var colp4 = "";
          var colp5 = "";
          if (d.id > 0){
            colp3 = "accordion-button collapsed";       
            colp4 = "accordion-collapse collapse";
            colp5 = "false"
          }
          if (d.id === 0){
            colp3 = "accordion-button";
            colp4 = "accordion-collapse collapse show";
            colp5 = "true"
          }
         // console.log('Count:  ', d.files.length);
          return(
            <div className="accordion-item">
            <h2 className="accordion-header" id={head}>
              <button className={colp3} type="button" data-bs-toggle="collapse" data-bs-target={colp1} aria-expanded={colp5} aria-controls={colp2}>
                {d.folderName}
              </button>
            </h2>
            <div id={colp2} className={colp4} aria-labelledby={head} data-bs-parent="#accordionExample">
              <div className="accordion-body">
                <Files data={d.files}/>
              </div>
            </div>            
          </div>
          )
        })
    }
    </>
    </div>
    </div>
  );
}

export default Permits;
